// Nuansa foto. Dipakai di HP tamu sebelum foto dikirim, dan untuk pratinjau di halaman pembuatan album.
// Berbasis piksel (bukan ctx.filter) supaya jalan di semua browser, termasuk iPhone.
//   sat   = saturasi (1 = tetap)        con  = kontras (1 = tetap)
//   bri   = kecerahan tambahan          shift = tambahan warna [merah, hijau, biru]
//   fade  = angkat bagian gelap         vig  = gelap di sudut (0 sampai 1)
//   gray  = hitam putih
const P = {
  asli: null,
  hangat: { sat: 1.08, con: 1.04, bri: 6, shift: [14, 6, -12], fade: 4, vig: 0.12 },
  senja: { sat: 1.18, con: 1.06, bri: 2, shift: [26, -2, -22], fade: 6, vig: 0.22 },
  klasik: { sat: 0.78, con: 0.94, bri: 8, shift: [10, 4, -8], fade: 22, vig: 0.28 },
  mono: { gray: true, con: 1.14, bri: 2, fade: 6, vig: 0.2 },
  embun: { sat: 0.95, con: 1.02, bri: 10, shift: [-8, 2, 12], fade: 8, vig: 0.05 },
};

export function applyFilter(canvas, id) {
  const p = P[id];
  if (!p) return canvas;
  const ctx = canvas.getContext("2d");
  const { width: w, height: h } = canvas;
  const img = ctx.getImageData(0, 0, w, h);
  const d = img.data;
  const sat = p.sat ?? 1;
  const con = p.con ?? 1;
  const bri = p.bri ?? 0;
  const fade = p.fade ?? 0;
  const [sr, sg, sb] = p.shift || [0, 0, 0];
  const k = 1 - fade / 255;
  for (let i = 0; i < d.length; i += 4) {
    let r = d[i];
    let g = d[i + 1];
    let b = d[i + 2];
    const l = 0.299 * r + 0.587 * g + 0.114 * b;
    if (p.gray) {
      r = g = b = l;
    } else {
      r = l + (r - l) * sat;
      g = l + (g - l) * sat;
      b = l + (b - l) * sat;
    }
    r = (r - 128) * con + 128 + bri + sr;
    g = (g - 128) * con + 128 + bri + sg;
    b = (b - 128) * con + 128 + bri + sb;
    d[i] = r * k + fade; // nilai di luar 0..255 otomatis dipotong
    d[i + 1] = g * k + fade;
    d[i + 2] = b * k + fade;
  }
  ctx.putImageData(img, 0, 0);
  if (p.vig) {
    const gr = ctx.createRadialGradient(w / 2, h / 2, Math.min(w, h) * 0.35, w / 2, h / 2, Math.hypot(w, h) / 2);
    gr.addColorStop(0, "rgba(0,0,0,0)");
    gr.addColorStop(1, `rgba(0,0,0,${p.vig})`);
    ctx.fillStyle = gr;
    ctx.fillRect(0, 0, w, h);
  }
  return canvas;
}

// Gambar kecil untuk pratinjau nuansa
export function drawThumb(canvas, img, id, max = 260) {
  const r = Math.min(1, max / Math.max(img.width, img.height));
  canvas.width = Math.max(1, Math.round(img.width * r));
  canvas.height = Math.max(1, Math.round(img.height * r));
  canvas.getContext("2d").drawImage(img, 0, 0, canvas.width, canvas.height);
  applyFilter(canvas, id);
}
